import React from 'react';
import './loader.css'
import logo from '../../../assets/images/logo-spinner-fastcapital.png'
const Loader = () => {
  return (
    <div className="position-fixed w-100 h-100 d-flex align-items-center justify-content-center section-spinner">
      <img src={logo} alt="Loading..." className="img-spinner img-fluid animate-spin-slow" />
    </div>
  );
};

export default Loader;
